// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2yCrm","content":"RecentSearches_content__27hHq"};